export default "__VITE_ASSET__CcAcGT8r__"